import { useToast } from '@chakra-ui/react';
import React from 'react';
import GoogleFontLoader from 'react-google-font-loader';
import { useDispatch, useSelector } from 'react-redux';
import { customFonts, selectCustomFonts } from '../../redux/customFontsSlice';
import { getAuthHeader } from '../../utils/auth-token';

const GoogleFontLoaderSA = ({ viewId }) => {
	const dispatch = useDispatch();
	const toast = useToast();
	//algumas das fontes default do io
	const fonts = useSelector(customFonts);
	const [fontsToRender, setFontsToRender] = React.useState([]);

	React.useEffect(() => {
		fetch(`${process.env.REACT_APP_COMPILER_URL}/api/tachyons/getJSON/${viewId}`, { headers: getAuthHeader() })
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp?.customFonts?.length) {
					dispatch(selectCustomFonts(resp.customFonts));
				}
			})
			.catch(() => {
				toast(fontError);
			});
	}, []);

	React.useEffect(() => {
		setFontsToRender(fonts?.filter((f) => !['sans-serif', 'palatino', 'calibri'].includes(f.font.toLowerCase())));
	}, [fonts]);

	return fontsToRender?.length ? <GoogleFontLoader fonts={fontsToRender} /> : null;
};

export default GoogleFontLoaderSA;
const fontError = {
	title: `Ocorreu um erro ao tentar recuperar as fontes`,
	status: 'error',
	duration: 10000,
	isClosable: true,
	position: 'top',
};
